import * as React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as _ from 'lodash'
import {Decimal} from 'decimal.js';
import SaleStepProducts from '../../components/sales/SaleStepProducts';
import SaleStepPaid from '../../components/sales/SaleStepPaid';
import SaleStepAdditionalFields from '../../components/sales/SaleStepAdditionalFields';
import SaleStepResult from '../../components/sales/SaleStepResult';
import SaleStepBadRequest from '../../components/sales/SaleStepBadRequest';
import SaleStepHelp from '~/apps/pos/mobile/components/sales/SaleStepHelp';
import {getLocationProducts} from '../../../shared/actions/products';
import {getLocationById} from '~/apps/shared/actions/locations';
import {getOrganizationById} from '~/apps/shared/actions/organizations';
import {
  createSale,
  getSaleById,
  getSaleList,
  paySaleByCheckout,
  paySaleByCode,
  paySaleByOther,
  updateSale
} from '~/apps/pos/shared/actions/sales';
import {getFieldsArrayOrgId} from '~/apps/pos/shared/actions/additionalFields';
import {navigate} from '~/router';
import {AdditionalFieldArray, saleGetListParamsURL} from '~/apps/pos/models';
import {
  createBodyData,
  groupingProductForSaleForm,
  parseFormData,
  productMaximumAmounts,
  productPrices,
  productType,
} from '~/apps/pos/shared/services/utils';
import {printPdf} from '~/apps/pos/shared/services/print';
import {sendMessageEmail, sendMessageSMS} from '~/apps/pos/shared/actions/message';
import SaleStepCode from "~/apps/pos/mobile/components/sales/SaleStepCode";
import {getFilteredPaymentTypeNames, isSaleEditable, PaymentType} from "~/apps/pos/shared/services/helpers";
import SaleStepRemote from "~/apps/pos/mobile/components/sales/SaleStepRemote";
import SaleStepInfo from "~/apps/pos/mobile/components/sales/SaleStepInfo";
import SaleStepProcessingResult from "~/apps/pos/mobile/components/sales/SaleStepProcessingResult";
import {defaultTablePageSize} from "~/common/components/consts";
import { Features } from "~/apps/shared/consts";
import {createRouteNodeSelector} from "redux-router5";
import {parseSaleFilter, saleFilterParams} from "~/apps/pos/shared/services/qsfilter";
import { SearchableModelHelper } from "~/lib/forms/select";
import { createOrgLocationsHelper } from "~/apps/shared/services/forms";

export type Reg = {
  locationId: string,
  departmentId: string,
  shift: string,
  organizationId: number,
  poNumber: string,
  company: string,
  description: string,
  paymentType: string,
  relayCode: string,
  driverPhone: string,
  initial?: boolean,
  arrivalTime: Date;
  checkInTime: Date;
};

export type State = {
  step: number,
  stepMax: number,
  total: Decimal,
  req: Reg,
  result: any,
  additionalFields: AdditionalFieldArray,
  isLoad?: boolean,
  payErrorMessage: string,
};

export class steps {
  static PRODUCTS = 0;

  static MAIN_INFO = 1;

  static ADDITIONAL_FIELD = 2;

  static PAID_TYPE = 3;

  static RELAY_CODE = 4;

  static REMOTE_CHEKOUT = 5;

  static RESULT = 6;

  static BAD_MAIN = 7;

  static BAD_PAYMENT = 8;

  static HELP = 9;

  static PROCESSING_RESULT = 10;
}

export class fieldType {
  static STRING = 'string';

  static DECIMAL = 'decimal';

  static INT = 'int';

  static EMAIL = 'email';

  static STRING_SIX_DIGIT = 'string_six_digit';
}

class CreateSale extends React.Component<any, State> {
  private currentBackStep: any;
  private editableSaleChanged: boolean;
  private orgLocationsHelper: SearchableModelHelper;
  private defState: {
    result: null;
    total: Decimal;
    additionalFields: any[];
    step: number;
    stepMax: number;
    isLoad?: boolean;
    payErrorMessage: string;
    req: {
      organizationId: any;
      initial: null;
      locationId: any;
      departmentId: any;
      shift: string;
      poNumber: string;
      company: string;
      description: string;
      paymentType: null;
      relayCode: string;
      driverPhone: string;
      arrivalTime: Date;
      checkInTime: Date;
    }
  };
  private remoteCheckoutOnly: boolean;

  constructor(props) {
    super(props);
    const {
      saleId,
      auth: {
        currentUser: {
          locationId: userLocationId,
          organizationId,
          departmentId: userDepartmentId,
          shift: userShift,
        },
      },
    } = props;

    this.onStepNext = this.onStepNext.bind(this);
    this.onStepPrev = this.onStepPrev.bind(this);
    this.onStepHelp = this.onStepHelp.bind(this);
    this.onBackFromStepHelp = this.onBackFromStepHelp.bind(this);
    this.onChangeLocation = this.onChangeLocation.bind(this);
    this.setFormData = this.setFormData.bind(this);
    this.onMainFieldsIntroduced = this.onMainFieldsIntroduced.bind(this);
    this.onPaidMethodSelected = this.onPaidMethodSelected.bind(this);

    this.currentBackStep = null;
    this.defState = {
      step: 0,
      stepMax: steps.PAID_TYPE,
      total: new Decimal(0),
      result: null,
      additionalFields: [],
      payErrorMessage: null,
      req: {
        initial: null,
        locationId: userLocationId,
        departmentId: userDepartmentId,
        shift: !saleId ? userShift : "",
        organizationId,
        poNumber: '',
        company: '',
        description: '',
        paymentType: null,
        relayCode: '',
        driverPhone: '',
        arrivalTime: null,
        checkInTime: null,
      },
    };

    this.state = this.defState;
  }

  refresh = () => {
    this.forceUpdate();
  }

  componentDidMount(): void {
    const {
      getOrganizationByIdAction,
      getSaleByIdAction,
      auth: {currentUser: {locationId: userLocationId, organizationId}},
      saleId,
      information,
    } = this.props;

    getOrganizationByIdAction(organizationId);

    this.orgLocationsHelper = createOrgLocationsHelper(this.refresh, organizationId);

    this.remoteCheckoutOnly = false;
    const hasFhiFeature = information.entities.features.includes(Features.FHI);
    const disablePaymentTypes = information.entities.paymentTypes;
    const paymentTypes = getFilteredPaymentTypeNames(disablePaymentTypes);
    if (hasFhiFeature && paymentTypes.length === 1 && paymentTypes[0].key === PaymentType.REMOTE_CHECKOUT.key) {
      this.remoteCheckoutOnly = true;
    }

    if (saleId) {
      getSaleByIdAction(saleId).then(result => {
        const sale = result.entities.sales[saleId];
        if (!isSaleEditable(sale.status, sale.paymentType, sale.paymentId)) {
          this.onView(saleId);
        }

        this.onChangeLocation(sale.locationId, () => {
          this.fillFormWithEditableSale(sale);
        });
      });
    } else {
      this.onChangeLocation(userLocationId);
    }
  }

  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<State>, snapshot?: any) {
    if (this.editableSaleChanged !== undefined && !_.isEqual(prevState.req, this.state.req)) {
      this.editableSaleChanged = true;
    }
  }

  private fillFormWithEditableSale(sale) {
    const {req, additionalFields, stepMax} = this.state;
    const products = this.props.products.entities;
    const step = parseInt(this.props.step);
    const disablePaymentTypes = this.props.information.entities.paymentTypes;

    sale.items.forEach(item => {
      const productItem = products[item.product.id];
      if (productItem?.group && typeof productItem.group === 'object' && productItem.group.id && productItem.group.name) {
        req[`group_${productItem.group.id}`] = item.product.id;
      } else {
        if (productItem.type === productType.ITEM) {
          req[`item_${productItem.id}`] = item.quantity;
        } else if (productItem.type === productType.ITEM_NOT_DROPDOWN) {
          req[`item-not-dropdown_${productItem.id}`] = item.quantity;
        } else if (productItem.type === productType.SERVICE) {
          req[`service_${productItem.id}`] = 1;
        } else if (productItem.type === productType.CUSTOM) {
          req[`custom_${productItem.id}`] = item.price;
        }
      }
    });

    if (sale.additionalFields) {
      additionalFields.forEach(field => {
        req[field.id] = sale.additionalFields[field.name]
      });
    }

    req.departmentId = sale.department ? sale.department.id : '';
    req.shift = sale.shift ? sale.shift : '';
    req.poNumber = sale.poNumber ? sale.poNumber : '';
    req.company = sale.company ? sale.company : '';
    req.arrivalTime = sale.arrivalTime ? sale.arrivalTime : null;
    req.checkInTime = sale.checkInTime ? sale.checkInTime : null;
    req.description = sale.description ? sale.description : '';
    req.paymentType = sale.paymentType && getFilteredPaymentTypeNames(disablePaymentTypes).map(pt => pt.key).includes(sale.paymentType)
      ? sale.paymentType : null;

    this.setState({
      step: step && step >= 0 && step <= stepMax ? step : 0,
      req,
      result: sale,
    });
    this.editableSaleChanged = false;
  }

  onChangeLocation(locationId, successCallback = null) {
    const {
      getLocationByIdAction, getLocationProductsAction, getFieldsArrayAction, auth: {currentUser: {organizationId}}
    } = this.props;

    const setProd = () => {
      if (locationId) {
        getLocationByIdAction(locationId);

        // Get Products
        getLocationProductsAction(locationId).then((result) => {
          const {req} = this.state;

          this.setState({
            isLoad: false,
            req: {
              ...req,
              ...groupingProductForSaleForm(result.result.map(i => result.entities.products[i]), true),
            }
          });

          successCallback ? successCallback() : null;
        });
      } else {
        this.setState({isLoad: false});
      }
    };

    const getAdditional = () => {
      // Get Additional fields
      getFieldsArrayAction(organizationId).then((result) => {
        const {req: {departmentId, shift}} = this.state;
        const additional = result.reduce((a, i) => ({...a, [i.id]: null}), {});

        this.setState({
          ...this.defState,
          additionalFields: result,
          total: new Decimal(0),
          req: {
            ...additional,
            locationId,
            departmentId,
            shift,
            initial: true,
          }
        }, () => {
          setProd();
        });
      }).catch(() => {
        this.setState({
          additionalFields: [],
          isLoad: false,
        });
      });
    };

    this.setState({isLoad: true}, () => {
      getAdditional()
    });

  }

  onStepNext = (form) => {
    const {step, stepMax, additionalFields} = this.state;
    let _step;

    switch (step) {
      case steps.MAIN_INFO:
        if (additionalFields && additionalFields.length) {
          _step = steps.ADDITIONAL_FIELD;
        } else {
          this.onMainFieldsIntroduced(form);
        }
        break;
      case steps.PAID_TYPE:
        if (form.paymentType === PaymentType.RELAY.key) {
          _step = steps.RELAY_CODE;
        } else if (form.paymentType === PaymentType.REMOTE_CHECKOUT.key) {
          _step = steps.REMOTE_CHEKOUT;
        } else {
          this.onPaidMethodSelected(form)
        }
        break;
      default:
        _step = step < stepMax ? step + 1 : step;
        break;
    }
    if (_step) this.setState({step: _step})
  };

  onStepPrev = () => {
    const {step, additionalFields} = this.state;
    let _step;

    const getLastInfoStep = () => {
      if (additionalFields && additionalFields.length) {
        return steps.ADDITIONAL_FIELD;
      } else {
        return steps.MAIN_INFO;
      }
    }

    switch (step) {
      case steps.REMOTE_CHEKOUT:
        if (!this.remoteCheckoutOnly) {
          _step = steps.PAID_TYPE;
        } else {
          _step = getLastInfoStep();
        }
        break;
      case steps.BAD_MAIN:
      case steps.PAID_TYPE:
        _step = getLastInfoStep();
        break;
      case steps.BAD_PAYMENT:
        this.setState({payErrorMessage: null});
        _step = steps.PAID_TYPE;
        break;
      case steps.PRODUCTS:
      case steps.PROCESSING_RESULT:
        this.stepEnd();
        break;
      default:
        _step = step > 0 ? step - 1 : step;
        break;
    }

    this.setState({
      step: _step,
    });
  };

  onBackFromStepHelp(currentStep) {
    this.setState({
      step: currentStep,
    })
  };

  onStepHelp(currentStep) {
    this.currentBackStep = currentStep;

    this.setState({
      step: steps.HELP,
    })
  };

  stepEnd = () => {
    const {isAgent, filter} = this.props;
    if (!isAgent) {
      navigate('pos.mobile.history');
    } else {
      navigate('pos.admin.sales', saleFilterParams(filter));
    }
  };

  onView = (saleId) => {
    const {isAgent, filter} = this.props;

    if (!isAgent) {
      navigate('pos.mobile.view', {saleId});
    } else {
      navigate('pos.admin.sales.detail', {saleId, ...saleFilterParams(filter)});
    }
  }

  setFormData(dataObj, rootObj = {}) {
    const {req} = this.state;
    this.setState({
      ...rootObj,
      req: {
        ...req,
        ...dataObj,
      }
    });
  }

  updateSaleHistoryList = () => {
    const {getSaleListAction, filter} = this.props;

    const req = {
      offset: 0,
      limit: defaultTablePageSize
    } as saleGetListParamsURL;

    if (filter?.locationId) {
      req.locationId = filter.locationId;
    }
    if (filter?.q) {
      req.q = filter.q;
    }
    if (filter?.status) {
      req.status = filter.status;
    }
    if (filter?.departmentId) {
      req.departmentId = filter.departmentId;
    }
    if (filter?.startDt) {
      req.startDt = filter.startDt;
    }
    if (filter?.endDt) {
      req.endDt = filter.endDt;
    }

    getSaleListAction(req).catch();
  };

  onMainFieldsIntroduced(data) {
    const {
      saleId,
      filter,
      products,
      updateSaleAction,
      createSaleAction,
      isAgent,
      organizations,
      auth: {currentUser: {organizationId}},
      locations,
      information
    } = this.props;
    const organization = organizations.entities[organizationId];
    const prices = productPrices(products.entities);
    const maximumAmounts = productMaximumAmounts(products.entities);
    const selectedLocation = data.locationId && locations.entities[data.locationId];
    const hasLocationAdministrativeFeeFeature = Array.isArray(information.entities.features)
      && information.entities.features.includes(Features.ENABLE_LOCATION_ADMINISTRATIVE_FEE);
    const administrativeFee = hasLocationAdministrativeFeeFeature && selectedLocation && selectedLocation.administrativeFee ? selectedLocation.administrativeFee
      : organization && organization.administrativeFee;
    const administrativeFeeMode = selectedLocation && selectedLocation.administrativeFeeMode ? selectedLocation.administrativeFeeMode
      : organization && organization.administrativeFeeMode;
    const hasApplyMaximumDollarAmountsFeature = Array.isArray(information.entities.features)
      && information.entities.features.includes(Features.APPLY_MAXIMUM_DOLLAR_AMOUNTS);
    const parseData = parseFormData(data, prices, administrativeFee, administrativeFeeMode, hasApplyMaximumDollarAmountsFeature, maximumAmounts);
    const bodyData = createBodyData(parseData, this.state);
    let nextPaymentTypeStep = !this.remoteCheckoutOnly ? steps.PAID_TYPE : steps.REMOTE_CHEKOUT;

    if (!saleId) {
      createSaleAction(bodyData).then((result) => {
        const createdSaleId = result.id;
        if (!isAgent) {
          navigate('pos.mobile.editSale', {saleId: createdSaleId}, {step: steps.PAID_TYPE});
        } else {
          navigate('pos.admin.sales.edit', {saleId: createdSaleId, ...saleFilterParams(filter)}, {step: steps.PAID_TYPE});
        }
        this.setState({
          step: nextPaymentTypeStep,
          result
        });
        this.editableSaleChanged = false;
        this.updateSaleHistoryList();
      }).catch(() => {
        this.setState({
          step: steps.BAD_MAIN,
        });
      });
    } else {
      if (this.editableSaleChanged) {
        updateSaleAction(saleId, bodyData).then((result) => {
          this.editableSaleChanged = false;
          this.setState({
            step: nextPaymentTypeStep,
            result
          });
          this.updateSaleHistoryList();
        }).catch(() => {
          this.setState({
            step: steps.BAD_MAIN
          })
        })
      } else {
        this.setState({step: nextPaymentTypeStep});
      }
    }
  }

  onPaidMethodSelected(data) {
    const {saleId, paySaleCodeAction, paySaleCheckoutAction, paySaleByOtherAction} = this.props;
    const {step} = this.state;

    if (saleId) {
      switch (step) {
        case steps.RELAY_CODE:
          paySaleCodeAction(saleId, {code: data.code}).then(() => {
            this.setState({step: steps.RESULT});
            this.updateSaleHistoryList();
          }).catch((error) => {
            this.setState({
              step: steps.BAD_PAYMENT,
              payErrorMessage: error.message,
            });
            this.updateSaleHistoryList();
          })
          return;
        case steps.REMOTE_CHEKOUT:
          const {driverPhone} = data;
          paySaleCheckoutAction(saleId, {driverPhone}).then(() => {
            this.setState({step: steps.PROCESSING_RESULT});
            this.updateSaleHistoryList();
          }).catch((error) => {
            this.setState({
              step: steps.BAD_PAYMENT,
              payErrorMessage: error.message,
            });
            this.updateSaleHistoryList();
          })
          return;
        default:
          paySaleByOtherAction(saleId, {type: data.paymentType}).then(() => {
            this.setState({step: steps.RESULT});
            this.updateSaleHistoryList();
          }).catch((error) => {
            this.setState({
              step: steps.BAD_PAYMENT,
              payErrorMessage: error.message,
            });
            this.updateSaleHistoryList();
          })
          return;
      }
    }
    this.setState({
      step: steps.BAD_MAIN
    })
  }

  handleButtonAction = (action, options) => {
    const { isAgent, filter } = this.props;
    const saleResult = this.state.result;

    switch (action) {
      case 'receipt-print':
        if (saleResult && saleResult.receiptUrl) {
          printPdf(saleResult.receiptUrl);
        }
        break;
      case 'request-sms':
        if (options && options.saleId && options.phone) {
          sendMessageSMS(options);
        }
        break;
      case 'request-email':
        if (options && options.saleId && options.email) {
          sendMessageEmail(options);
        }
        break;
      case 'result-done':
        if (!isAgent) {
          navigate('pos.mobile.history');
        } else {
          navigate('pos.admin.sales', saleFilterParams(filter));
        }
        break;
      case 'on-click-right':
        this.onStepHelp(steps.RESULT);
        break;
      case 'on-click-left':
        this.stepEnd();
        break;
      default:
        console.warn(`Not button action: ${action} !!!`);
    }
  };

  render() {
    const {
      saleId,
      products,
      auth: {
        currentUser: {
          organizationId,
          locationId: userLocationId,
          departmentId: userDepartmentId,
          shift: userShift
        }
      },
      organizations,
      locations,
      departments,
      information,
      isDesktop
    } = this.props;
    const {step, total, additionalFields, req, isLoad, payErrorMessage, result} = this.state;
    const isInitial = !!req.initial;
    const disablePaymentTypes = information.entities.paymentTypes;
    const hasArrivalAndCheckInTimeFeature = Array.isArray(information.entities.features)
      && information.entities.features.includes(Features.ARRIVAL_TIME_CHECK_IN_TIME);
    const hasDepartmentFeature = Array.isArray(information.entities.features)
      && information.entities.features.includes(Features.DEPARTMENTS);
    const hasFHIFeature = Array.isArray(information.entities.features)
      && information.entities.features.includes(Features.FHI);
    const hasLocationAdministrativeFeeFeature = Array.isArray(information.entities.features)
      && information.entities.features.includes(Features.ENABLE_LOCATION_ADMINISTRATIVE_FEE);
    const hasConvenienceFeeTextInSaleFeature = Array.isArray(information.entities.features)
      && information.entities.features.includes(Features.ADD_CONVENIENCE_FEE_TEXT_TO_SALE);
    const hasApplyMaximumDollarAmountsFeature = Array.isArray(information.entities.features)
      && information.entities.features.includes(Features.APPLY_MAXIMUM_DOLLAR_AMOUNTS);
    const hasHidePoNumberFeature = Array.isArray(information.entities.features)
      && information.entities.features.includes(Features.PO_NUMBER_NOT_REQUIRED);

    switch (step) {
      case steps.PRODUCTS:
        if (isInitial) {
          return (
            <SaleStepProducts
              products={products}
              organization={organizations.entities[organizationId]}
              userLocation={locations.entities[userLocationId]}
              orgLocationsHelper={this.orgLocationsHelper}
              initialValues={req}
              onBack={!isDesktop ? this.onStepPrev : null}
              onHelp={!isDesktop ? this.onStepHelp : null}
              onClose={isDesktop ? this.stepEnd : null}
              onSubmit={this.onStepNext}
              formData={this.state}
              setFormData={this.setFormData}
              onChangeLocation={this.onChangeLocation}
              actionKeyBack={steps.PRODUCTS}
              isLoad={isLoad}
              hasDepartmentFeature={hasDepartmentFeature}
              hasFHIFeature={hasFHIFeature}
              userDepartment={departments.entities[userDepartmentId]}
              userShift={!saleId ? userShift : ""}
              departments={departments.ui.currentList.map(id => departments.entities[id])}
              hasLocationAdministrativeFeeFeature={hasLocationAdministrativeFeeFeature}
              hasConvenienceFeeTextInSaleFeature={hasConvenienceFeeTextInSaleFeature}
              hasApplyMaximumDollarAmountsFeature={hasApplyMaximumDollarAmountsFeature}
            />
          );
        } else return null;
      case steps.MAIN_INFO:
        return (
          <SaleStepInfo
            initialValues={req}
            total={total}
            onBack={this.onStepPrev}
            onHelp={!isDesktop ? this.onStepHelp : null}
            onClose={isDesktop ? this.stepEnd : null}
            onSubmit={this.onStepNext}
            setFormData={this.setFormData}
            actionKeyBack={steps.MAIN_INFO}
            showTimeInputs={hasArrivalAndCheckInTimeFeature}
            features={information.entities.features}
            hasHidePoNumberFeature={hasHidePoNumberFeature}
          />
        )
      case steps.ADDITIONAL_FIELD:
        return (
          <SaleStepAdditionalFields
            initialValues={req}
            onBack={this.onStepPrev}
            onHelp={!isDesktop ? this.onStepHelp : null}
            onClose={isDesktop ? this.stepEnd : null}
            onSubmit={this.onMainFieldsIntroduced}
            setFormData={this.setFormData}
            additionalFields={additionalFields}
            actionKeyBack={steps.ADDITIONAL_FIELD}
          />
        );
      case steps.PAID_TYPE:
        return (
          <SaleStepPaid
            initialValues={req}
            isDesktop={isDesktop}
            onBack={this.onStepPrev}
            onHelp={this.onStepHelp}
            onClose={isDesktop ? this.stepEnd : null}
            onSubmit={this.onStepNext}
            setFormData={this.setFormData}
            actionKeyBack={steps.PAID_TYPE}
            disablePaymentTypes={disablePaymentTypes}
          />
        );
      case steps.RELAY_CODE:
        return (
          <SaleStepCode
            initialValues={req}
            onBack={this.onStepPrev}
            onHelp={this.onStepHelp}
            onSubmit={this.onPaidMethodSelected}
            setFormData={this.setFormData}
            actionKeyBack={steps.RELAY_CODE}
          />
        );
      case steps.REMOTE_CHEKOUT:
        return (
          <SaleStepRemote
            initialValues={req}
            onBack={this.onStepPrev}
            onHelp={this.onStepHelp}
            onSubmit={this.onPaidMethodSelected}
            setFormData={this.setFormData}
            actionKeyBack={steps.REMOTE_CHEKOUT}
          />
        )
      case steps.PROCESSING_RESULT:
        return (
          <SaleStepProcessingResult
            onHelp={this.onStepHelp}
            onBack={this.onStepPrev}
            result={result}
            actionKeyBack={steps.PROCESSING_RESULT}
            onView={this.onView}
          />
        )
      case steps.RESULT:
        return (
          <SaleStepResult
            initialValues={req}
            result={result}
            onSubmit={this.onStepNext}
            handleActions={this.handleButtonAction}
            onView={this.onView}
            features={information.entities.features}
          />
        );
      case steps.BAD_MAIN:
      case steps.BAD_PAYMENT:
        return (
          <SaleStepBadRequest
            onBack={this.onStepPrev}
            onHelp={this.onStepHelp}
            initialValues={req}
            actionKeyBack={step}
            errorMessage={payErrorMessage}
          />
        );
      case steps.HELP:
        return (
          <SaleStepHelp
            onBack={this.onBackFromStepHelp}
            actionKey={this.currentBackStep}
          />
        );
    }
  }
}

const mapStateToProps = (state) => {
  const selector = createRouteNodeSelector('pos.admin');
  const {route: {params}} = selector(state);

  // Get current filter and force expired
  const filter = parseSaleFilter(params);

  return {
    products: state.pos.products,
    locations: state.shared.locations,
    organizations: state.shared.organizations,
    auth: state.shared.auth,
    information: state.shared.information,
    departments: state.shared.departments,
    filter,
  }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getLocationProductsAction: getLocationProducts,
  getLocationByIdAction: getLocationById,
  getOrganizationByIdAction: getOrganizationById,
  createSaleAction: createSale,
  updateSaleAction: updateSale,
  paySaleCodeAction: paySaleByCode,
  paySaleCheckoutAction: paySaleByCheckout,
  paySaleByOtherAction: paySaleByOther,
  getFieldsArrayAction: getFieldsArrayOrgId,
  getSaleByIdAction: getSaleById,
  getSaleListAction: getSaleList,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CreateSale);
